export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxOloc6SjTjQJElg.e54cab92.woff2";